import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import { useOnboarding } from "@/context/OnboardingContext";

export default function EmailVerificationStep() {
  const navigate = useNavigate();
  const { state } = useOnboarding();

  return (
    <motion.div
      key="email-verification"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{
        duration: 0.5,
        ease: "easeInOut",
        opacity: { duration: 0.3 },
      }}
      className="w-full py-4"
    >
      <div className="w-full mx-auto">
        <div className="h-20 w-20 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
          <Mail className="h-10 w-10 text-primary" />
        </div>

        <h2 className="text-2xl font-bold mb-4">Check your email</h2>

        <p className="text-muted-foreground mb-6">
          We've sent a verification link to:
          <br />
          <span className="font-medium text-foreground">{state.verificationEmail}</span>
        </p>

        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Click the link in your email to verify your account and access your dashboard.
          </p>

          <div className="bg-muted/50 rounded-lg p-4 text-sm">
            <p className="font-medium mb-2">Can't find the email?</p>
            <ul className="space-y-2 text-muted-foreground">
              <li>• Check your spam folder</li>
              <li>• Make sure the email address is correct</li>
              <li>• Allow a few minutes for the email to arrive</li>
            </ul>
          </div>

          <div className="pt-4">
            <Button
              onClick={() => navigate("/auth")}
              variant="default"
              className="w-full"
            >
              Continue to Login
            </Button>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
